/**
 * Proposal Detail Page
 *
 * View a specific project proposal by ID.
 * Maps to /proposals/:id (was /quotations/[id] in vectorsell)
 */

import { useParams } from 'react-router-dom'

export default function ProposalDetailPage() {
  const { id } = useParams<{ id: string }>()

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">Proposal Details</h1>
      <p className="text-muted-foreground mb-4">
        Viewing proposal: <span className="font-mono">{id}</span>
      </p>

      <div className="bg-card p-6 rounded-lg border">
        <p className="text-sm text-muted-foreground">
          Content will be migrated from vectorsell/quotations/[id]
        </p>
      </div>
    </div>
  )
}
